export const GET_INTENT_ALL_REQUEST = 'GET_INTENT_ALL_REQUEST';
export const GET_INTENT_ALL_SUCCESS = 'GET_INTENT_ALL_SUCCESS';
export const GET_INTENT_ALL_ERROR = 'GET_INTENT_ALL_ERROR';
export const GET_INTENT_LIST_REQUEST = 'GET_INTENT_LIST_REQUEST';
export const GET_INTENT_LIST_SUCCESS = 'GET_INTENT_LIST_SUCCESS';
export const GET_INTENT_LIST_ERROR = 'GET_INTENT_LIST_ERROR';
export const ADD_INTENT_REQUEST = 'ADD_INTENT_REQUEST';
export const ADD_INTENT_SUCCESS = 'ADD_INTENT_SUCCESS';
export const ADD_INTENT_ERROR = 'ADD_INTENT_ERROR';
export const GET_INTENT_REQUEST = 'GET_INTENT_REQUEST';
export const GET_INTENT_SUCCESS = 'GET_INTENT_SUCCESS';
export const GET_INTENT_ERROR = 'GET_INTENT_ERROR';
export const UPDATE_INTENT_REQUEST = 'UPDATE_INTENT_REQUEST';
export const UPDATE_INTENT_SUCCESS = 'UPDATE_INTENT_SUCCESS';
export const UPDATE_INTENT_ERROR = 'UPDATE_INTENT_ERROR';
export const PARTIAL_UPDATE_INTENT_REQUEST = 'PARTIAL_UPDATE_INTENT_REQUEST';
export const PARTIAL_UPDATE_INTENT_SUCCESS = 'PARTIAL_UPDATE_INTENT_SUCCESS';
export const PARTIAL_UPDATE_INTENT_ERROR = 'PARTIAL_UPDATE_INTENT_ERROR';
export const DELETE_INTENT_REQUEST = 'DELETE_INTENT_REQUEST';
export const DELETE_INTENT_SUCCESS = 'DELETE_INTENT_SUCCESS';
export const DELETE_INTENT_ERROR = 'DELETE_INTENT_ERROR';
export const UPDATE_INTENT_LIST_OPTIONS = 'UPDATE_INTENT_LIST_OPTIONS';
export const UPDATE_INTENT_LIST_PAGINATION_OPTIONS =
  'UPDATE_INTENT_LIST_PAGINATION_OPTIONS';
export const UPDATE_INTENT_LIST_FILTER_OPTIONS =
  'UPDATE_INTENT_LIST_FILTER_OPTIONS';
export const SELECT_INTENT = 'SELECT_INTENT';
export const DESELECT_INTENT = 'DESELECT_INTENT';
export const TRAIN_REQUEST = 'TRAIN_REQUEST';
export const TRAIN_SUCCESS = 'TRAIN_SUCCESS';
export const TRAIN_ERROR = 'TRAIN_ERROR';
export const PARTIAL_EXPORT_INTENT_REQUEST = 'PARTIAL_EXPORT_INTENT_REQUEST';
export const PARTIAL_EXPORT_INTENT_COMPLETE = 'PARTIAL_EXPORT_INTENT_COMPLETE';
export const PARTIAL_EXPORT_INTENT_CANCEL = 'PARTIAL_EXPORT_INTENT_CANCEL';

export const PARTIAL_IMPORT_INTENT_REQUEST = 'PARTIAL_IMPORT_INTENT_REQUEST';
export const PARTIAL_IMPORT_INTENT_COMPLETE = 'PARTIAL_IMPORT_INTENT_COMPLETE';
export const PARTIAL_IMPORT_INTENT_CANCEL = 'PARTIAL_IMPORT_INTENT_CANCEL';
